import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideLottieOptions } from 'ngx-lottie';

/** Lazy-loads lottie-web when the first animation is shown. */
export function provideOvinoLottie(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
  ]);
}
